export function StartScene(originScene, targetScene, data?, unload = true) {
  if (unload) originScene.unloadAssets();
  originScene.scene.start(targetScene, data);
}
